module.exports = __webpack_public_path__ + "static/media/apartment1.9c560eb7.jpg";